import { BrandsApi } from '../../api/BrandsApi'
import { CaasApi } from '../../api/CaasApi'
import { CaeApi } from '../../api/CaeApi'
import { CMS_CAAS_ENABLED } from '../../api/CmsApi'
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from '../reducers/index'

const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat([
			BrandsApi.middleware,
			CMS_CAAS_ENABLED ? CaasApi.middleware : CaeApi.middleware,
		]),
})

export type AppStore = typeof store
export type AppState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export default store
